<div class="filter-bar card-body" *ngIf="!isLoadTemplate">
  <div class="d-flex flex-wrap" [formGroup]="formGroup">
    <div *ngFor="let data of filterData" class="mr-3" [ngClass]="classCustom ? classCustom : {'item-filter': !portal, 'clinic-filter': portal }">
      <ng-container [ngSwitch]="data.type">

        <ng-container *ngSwitchCase="'dropdown'">
          <dcu-select
            customLabel="All"
            [label]="data.label"
            [formControlName]="data.controlName"
            [dropdownList]="data.dropdownList"
            [bindingKey]= "data.bindingKey"
            [multiple]="data.multiple"
            [selectId]="data.idName"
            [badgeShowLimit]="2"
            (storedItemsChanged)="onChangeData($event,data)"
            [lazyLoad]="data.isLazyLoading"
            [customSearch]="data.isLazyLoading"
            [lazyLoadParameter$]="data.lazyLoadParameter$"
            (clearValue)="onClearValueDropdown($event)"
          ></dcu-select>
        </ng-container>

        <ng-container *ngSwitchCase="'date'">
          <dcu-date-picker
            [label]="data.label"
            [formControlName]="data.controlName"
            [id]="data.idName"
            (selectedValueChange)="validateFromTo($event, data)"
            [isFormatted]="isFormatted"
            [maxDate]="data.maxDate ? data.maxDate : null"
            [minDate]="data.minDate ? data.minDate : null"
          ></dcu-date-picker>
        </ng-container>

        <ng-container *ngSwitchCase="'amount'">
          <dcu-input-text
            [label]="data.label"
            [formControlName]="data.controlName"
            [id]="data.idName"
            [type]="'number'"
            [maxIntegerNumber]="13"
            [maxFractionNumber]="4"
            [maxLength]="17"
            [isDecimal]="true"
            [formattedValue]="true"
            (onBlurValue)="validateFromTo($event, data)"
          ></dcu-input-text>
        </ng-container>

        <ng-container *ngSwitchCase="'hidden'">
          <input type="hidden" class="form-control form-input" formControlName="{{data.controlName}}" id="{{data.idName}}" value="{{data.defaultValue}}" placeholder="{{data.placeholder}}"/>
        </ng-container>
      </ng-container>

    </div>
    <div class="horizontal-button mr-3" style="max-width: 10%;">
      <div class="col-form-label" style="opacity: 0;">label</div>
      <button
        (click)="onFilter()"
        type="button"
        class="btn btn-primary button-apply" [disabled]="disableTriggerBtn"
        id="{{idFilter}}-apply-button"
      >
        {{triggerBtnName}}
      </button>
    </div>
    <div class="horizontal-button">
      <div class="col-form-label" style="opacity: 0;">label</div>
      <button class="btn btn-ghost-primary button-cancel" (click)="cancelFilter()" type="button" id="{{idFilter}}-cancel-button">{{cancelBtnName}}</button>
    </div>

  </div>
  <div *ngIf="errorMessage" class="is-invalid" style="padding-top: 10px;">
    {{errorMessage}}
  </div>

</div>
